import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-agree',
  templateUrl: './agree.component.html',
  styleUrls: ['./agree.component.scss']
})
export class AgreeComponent {

  constructor() { }

}
